import type { MessengerMessage, MessengerLikeLikerPreview } from '@/api/client';

/** API/pg могут отдать file_size как string (BIGINT) — приводим к числу байт. */
export function parseMessengerFileSizeBytes(raw: unknown): number | null {
  if (raw == null || raw === '') return null;
  const n = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw) : Number.NaN;
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.trunc(n);
}

function parseMessengerImageDimension(raw: unknown): number | null {
  if (raw == null || raw === '') return null;
  const n = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw) : Number.NaN;
  if (!Number.isFinite(n)) return null;
  const t = Math.trunc(n);
  return t > 0 ? t : null;
}

export function normalizeLikeLikersPreview(raw: unknown): MessengerLikeLikerPreview[] {
  if (!Array.isArray(raw)) return [];
  const out: MessengerLikeLikerPreview[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const o = item as Record<string, unknown>;
    const pid = String(o.person_id ?? '').trim();
    if (!pid) continue;
    const av = o.avatar_url;
    out.push({
      person_id: pid,
      first_name: o.first_name != null && String(o.first_name) !== '' ? String(o.first_name) : null,
      last_name: o.last_name != null && String(o.last_name) !== '' ? String(o.last_name) : null,
      avatar_url: av != null && String(av).trim() !== '' ? String(av) : null,
    });
    if (out.length >= 3) break;
  }
  return out;
}

function isSameLikers(
  a: MessengerLikeLikerPreview[] | undefined,
  b: MessengerLikeLikerPreview[]
): boolean {
  const cur = a ?? [];
  if (cur.length !== b.length) return false;
  for (let i = 0; i < b.length; i++) {
    const x = cur[i];
    const y = b[i];
    if (!x || !y) return false;
    if (x.person_id !== y.person_id) return false;
    if (x.first_name !== y.first_name || x.last_name !== y.last_name || x.avatar_url !== y.avatar_url) {
      return false;
    }
  }
  return true;
}

export function normalizeMessengerMessage(msg: MessengerMessage): MessengerMessage {
  const messageKind: 'user' | 'system' = msg.message_kind === 'system' ? 'system' : 'user';
  const fs = parseMessengerFileSizeBytes(msg.file_size);
  const iw = parseMessengerImageDimension(msg.image_width);
  const ih = parseMessengerImageDimension(msg.image_height);
  const likeCount =
    typeof msg.like_count === 'number' && Number.isFinite(msg.like_count) && msg.like_count >= 0
      ? Math.trunc(msg.like_count)
      : 0;
  const likedByMe = Boolean(msg.liked_by_me);
  const isPinned = Boolean(msg.is_pinned);
  const likersNorm = normalizeLikeLikersPreview(msg.like_likers_preview);
  const prevLc = typeof msg.like_count === 'number' && Number.isFinite(msg.like_count) ? Math.trunc(msg.like_count) : 0;
  if (
    messageKind === msg.message_kind &&
    fs === msg.file_size &&
    iw === msg.image_width &&
    ih === msg.image_height &&
    prevLc === likeCount &&
    Boolean(msg.liked_by_me) === likedByMe &&
    Boolean(msg.is_pinned) === isPinned &&
    isSameLikers(msg.like_likers_preview, likersNorm)
  ) {
    return msg;
  }
  return {
    ...msg,
    message_kind: messageKind,
    file_size: fs,
    image_width: iw,
    image_height: ih,
    like_count: likeCount,
    liked_by_me: likedByMe,
    is_pinned: isPinned,
    like_likers_preview: likersNorm,
  };
}
